<template>
  <div class="domain-dropdown" ref="wrapper">
    <button class="domain-dropdown__trigger" @click.stop="toggleOpen">
      <span>{{ triggerLabel }}</span>
      <i class="fas fa-chevron-down domain-dropdown__chevron" :class="{ 'is-open': isOpen }"></i>
    </button>

    <div v-if="isOpen" class="domain-dropdown__panel" @click.stop>
      <div class="domain-dropdown__header">
        <span class="domain-dropdown__title">Select Domain</span>
        <span class="domain-dropdown__hint">Select up to {{ maxSelect }}</span>
      </div>

      <!-- <div class="domain-dropdown__search-wrap">
        <input v-model="search" class="domain-dropdown__search-input" placeholder="Search domain" @click.stop />
      </div> -->

      <div class="domain-dropdown__search-wrap">
        <i class="fas fa-search domain-dropdown__search-icon"></i>
        <span>
          <span v-for="opt in selected" :key="opt.value" class="domain-dropdown__chip" @click.stop="toggleOption(opt)">
            {{ opt.name }}
            <span class="domain-dropdown__chip-remove">×</span>
          </span>
          <span v-if="selected.length > 0" class="domain-dropdown__clear-all" @click.stop="clearAll">×</span>
        </span>
        <input v-model="search" class="domain-dropdown__search-input" placeholder="Search domain" @click.stop />
      </div>

      <div class="domain-dropdown__list">
        <label v-for="opt in filteredOptions" :key="opt.value" class="domain-dropdown__item"
          :class="{ 'is-disabled': isDisabled(opt) }">
          <input type="checkbox" class="domain-dropdown__checkbox" :checked="isChecked(opt)" :disabled="isDisabled(opt)"
            @change="toggleOption(opt)" />
          <span>{{ opt.name }}</span>
        </label>
        <p v-if="filteredOptions.length === 0" class="domain-dropdown__empty">No results</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DomainCheckboxDropdown",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    maxSelect: {
      type: Number,
      default: 3,
    },
    placeholder: {
      type: String,
      default: "All Domains",
    },
  },
  data() {
    return {
      isOpen: false,
      search: "",
    };
  },
  computed: {
    selected() {
      return this.value || [];
    },
    triggerLabel() {
      if (!this.selected.length) return this.placeholder;
      return `Domain (${this.selected.length})`;
    },
    filteredOptions() {
      const q = this.search.toLowerCase();
      if (!q) return this.options;
      return this.options.filter((opt) => opt.name.toLowerCase().includes(q));
    },
  },
  mounted() {
    this._closeHandler = (e) => {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
        this.isOpen = false;
      }
    };
    document.addEventListener("click", this._closeHandler);
  },
  beforeDestroy() {
    document.removeEventListener("click", this._closeHandler);
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.search = "";
        this.$emit("open");
      }
    },
    close() {
      this.isOpen = false;
    },
    isChecked(opt) {
      return this.selected.some((s) => s.value === opt.value);
    },
    isDisabled(opt) {
      return !this.isChecked(opt) && this.selected.length >= this.maxSelect;
    },
    toggleOption(opt) {
      if (this.isChecked(opt)) {
        this.$emit(
          "input",
          this.selected.filter((s) => s.value !== opt.value),
        );
      } else if (this.selected.length < this.maxSelect) {
        this.$emit("input", [...this.selected, opt]);
      }
    },
    clearAll() {
      this.$emit("input", []);
    },
  },
};
</script>

<style scoped>
.domain-dropdown {
  position: relative;
  width: 100%;
}

.domain-dropdown__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  background: white;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  font-weight: 500;
  color: #4b4b4b;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.domain-dropdown__trigger:hover {
  background: #f5f5f5;
}

.domain-dropdown__chevron {
  font-size: 10px;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.domain-dropdown__chevron.is-open {
  transform: rotate(180deg);
}

.domain-dropdown__panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 220px;
  z-index: 10;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  padding: 13px;
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.domain-dropdown__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.domain-dropdown__title {
  font-size: 13px;
  font-weight: 500;
  color: #4b4b4b;
}

.domain-dropdown__hint {
  font-size: 12px;
  font-weight: 500;
  color: #a0a0a0;
}

.domain-dropdown__search-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 37px;
  padding: 6px 10px;
  border: 1px solid #e3e3e3;
  border-radius: 5px;
}

.domain-dropdown__search-icon {
  color: #e3e3e3;
  font-size: 14px;
  flex-shrink: 0;
}

.domain-dropdown__search-input {
  flex: 1;
  min-width: 80px;
  border: none;
  outline: none;
  font-size: 14px;
  color: #4b4b4b;
  background: transparent;
}

.domain-dropdown__search-input::placeholder {
  color: #e3e3e3;
}

.domain-dropdown__list {
  max-height: 160px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.domain-dropdown__list::-webkit-scrollbar {
  width: 4px;
}

.domain-dropdown__list::-webkit-scrollbar-track {
  background: transparent;
}

.domain-dropdown__list::-webkit-scrollbar-thumb {
  background: #e3e3e3;
  border-radius: 8px;
}

.domain-dropdown__item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  font-size: 14px;
  color: #393939;
  font-weight: 400;
  user-select: none;
}

.domain-dropdown__item.is-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.domain-dropdown__checkbox {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  border: 1px solid #d7d6d6;
  border-radius: 2px;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
}

.domain-dropdown__checkbox:checked {
  background: #4b4b4b;
  border-color: #4b4b4b;
}

.domain-dropdown__checkbox:checked::after {
  content: "";
  position: absolute;
  left: 2px;
  top: 0px;
  width: 5px;
  height: 8px;
  border: 2px solid white;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
}

.domain-dropdown__checkbox:disabled {
  cursor: not-allowed;
}

.domain-dropdown__empty {
  font-size: 12px;
  color: #a0a0a0;
  margin: 0;
  text-align: center;
}

.domain-dropdown__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1;
  align-items: center;
}

.domain-dropdown__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #4b7bec;
  color: white;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  margin: 2px 0;
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
}

.domain-dropdown__chip:hover {
  background: #3a6ad4;
}

.domain-dropdown__chip-remove {
  font-size: 14px;
  line-height: 1;
  opacity: 0.8;
}

.domain-dropdown__clear-all {
  font-size: 16px;
  color: #a0a0a0;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
}

.domain-dropdown__clear-all:hover {
  color: #4b4b4b;
}

.domain-dropdown__placeholder {
  color: #a0a0a0;
}
</style>
